import React, { Component, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { Route, useHistory, useLocation } from "react-router-dom";
import Cookies from "universal-cookie";
import { getUserInfo } from "../../store/selector/userSelector";
import Loader from "../../components/loader";
import NoIndexWrap from "../NoIndexWrap/NoIndexWrap";

const cookie = new Cookies();

function PrivateRoute(props) {
  const location = useLocation();
  const history = useHistory();
  const isAuth = cookie.get("user_token");
  const userInfo = useSelector(getUserInfo);
  const redirect = useMemo(() => (props.redirect ? props.redirect : "/login"), [props.redirect]);

  useEffect(() => {
    !isAuth && sessionStorage.setItem("redirect_to", location.pathname);
  }, []);

  if (isAuth && !userInfo?.id) {
    return <Loader />;
  }

  return (
    <>
      {isAuth ? (
        <NoIndexWrap>
          <Route {...props} render={(props) => <Component {...props} />} />
        </NoIndexWrap>
      ) : (
        history.push(redirect)
      )}
    </>
  );
}

export default PrivateRoute;
